import React, { Component, Fragment } from "react";
import noImage from "../../../../assets/images/noimage.png"

class BackgroundImageControl extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount = () => {};

  render() {
    return (
      <Fragment>
        <div className="selectedImageThumb">
          <img
            onError={(e) => {
              e.target.src = noImage;
            }}
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              maxWidth: "300px",
              maxHeight: "auto",
              boxShadow: "0 0 10px 0px #0078ff",
              border: "solid 1px #0078ff",
            }}
            src={this.props.bgImage}
          />
        </div>
        <div
          className="backgroundImageProperties columnCropBg"
          style={{
            padding: "0",
            marginBottom: "20px",
          }}
        >
          <div className="col-sm-6 bgRepeatWrapper">
            <label>Background Repeat</label>
            <div className="radiusToggle">
              <input
                onChange={this.props.bgRepeatChange}
                type="checkbox"
                id={this.props.repeat}
                checked={this.props.bgRepeat == "repeat"}
              />
            </div>
            <span>{this.props.bgRepeat}</span>
          </div>
          <div className="col-sm-6 bgRepeatWrapper">
            <label>Background Size</label>
            <div className="radiusToggle">
              <input
                onChange={this.props.bgSizeChange}
                type="checkbox"
                id={this.props.size}
                checked={this.props.bgSize == "cover"}
              />
            </div>
            <span>{this.props.bgSize}</span>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default BackgroundImageControl;
